import React, { useState, useEffect } from 'react';
import CustomTable from '../../../customComponents/CustomTable';
import { TABLE_HEADERS, keyMapping } from '../../../../constants/VehicleDetails';
import downloadIcon from "../../../../Assets/icons/download.svg";
import axiosInstance from '../../../services/api/API';

const VehicleList = ({ tableData ,formData,totalRecords,
  setFormData,setisEditMode,onPageChange,currentPage,totalPages }) => {
  const [data, setData] = useState(tableData);
  
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    setData(tableData); // Ensure data is populated correctly initially
  }, [tableData]);

  const handleDelete = async (rowData) => {
    try {
      const response = await axiosInstance.delete(`/logisticsstock/delete/${rowData.logistic_stock_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        // Create a new array without the deleted item
        const updatedData = data.filter(item => item.logistic_stock_id !== rowData.logistic_stock_id);
        setData(updatedData);
        console.log('Item deleted successfully');
      } else {
        console.error('Failed to delete item');
      }
    } catch (error) {
      console.error('Error deleting item:', error);
    }
  }

  const handleEdit = async (rowData) => {
    setisEditMode(true)
    try {
      const response = await axiosInstance.get(`/logisticsstock/edit/${rowData.logistic_stock_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const vehicleData = response.data.data; 
        console.log("vehicleData>>",vehicleData);
                
        const transformedData = {
          productname:vehicleData.product_id,
          variant: vehicleData.variant_id,
          subproduct:vehicleData?.subproduct_name,
          make: vehicleData.make_name,
          model: vehicleData.model_name,
          fueltype:vehicleData?.fuel_type_name,
          color:vehicleData?.color_name,
          selling_price:vehicleData?.selling_price,
          purchaseprice:vehicleData?.purchase_price
        
      };
        setFormData(transformedData)
    console.log("vehicleformData",formData);
    
      } else {
        console.error('Failed to fetch vehicle data');
      }
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    }
  }

  return (
    <div className='tableWrapper'>
      <div className='admin-list-container'>
        <div className='listsearchContainer'>
          <h5>Vehicle Code Details</h5>
        </div>
        {/* <div className='downloadiconwrapper'>
          <h6 className='downloadTitle'>Download</h6>
          <img src={downloadIcon} alt='download' />
        </div> */}
      </div>

      <CustomTable
        data={data}
        headers={TABLE_HEADERS}
        keyMapping={keyMapping}
        itemsPerPage={10}
        onEdit={handleEdit}
        onDelete={handleDelete}
        totalRecords={totalRecords}
        onPageChange={onPageChange}
        totalPages={totalPages}
        currentPage={currentPage}
        
      />
    </div>
  )
}

export default VehicleList;
